import { render } from "./PPAPApplicabilitySelfInspectionUpload.vue?vue&type=template&id=381e4e50&scoped=true"
import script from "./PPAPApplicabilitySelfInspectionUpload.vue?vue&type=script&lang=js"
export * from "./PPAPApplicabilitySelfInspectionUpload.vue?vue&type=script&lang=js"

import "./PPAPApplicabilitySelfInspectionUpload.vue?vue&type=style&index=0&id=381e4e50&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381e4e50"]])

export default __exports__